import React from 'react';
import { useNavigate } from 'react-router-dom';
import './styles/Chatconversation.css';

const ChatLimitPopup = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  // Function to thoroughly clean up Mermaid-related data
  const cleanupMermaidResources = () => {
    // console.log('Performing thorough Mermaid cleanup');
    try {
      // 1. Clear internal Mermaid cache using the clear method if available
      if (window.mermaid && typeof window.mermaid.clear === 'function') {
        window.mermaid.clear();
        // console.log('Successfully cleared Mermaid cache');
        
        // Additional cleanup - remove mermaid instances from DOM
        document.querySelectorAll('.mermaid, .mermaid-diagram, .mermaid-diagram-container').forEach(el => {
          if (el && el.parentNode) {
            try {
              el.parentNode.removeChild(el);
              // console.log('Removed Mermaid element from DOM');
            } catch (e) {
              // console.warn('Error removing Mermaid element:', e);
            }
          }
        });
      } else {
        console.warn('Mermaid clear method not available');
      }
      
      // 2. Remove syntax error elements from DOM
      document.querySelectorAll('.mermaid-error, [class*="syntax-error"], .bomb').forEach(el => {
        if (el && el.parentNode) {
          try {
            el.parentNode.removeChild(el);
            // console.log('Removed error element from DOM');
          } catch (e) {
            // console.warn('Error removing error element:', e);
          }
        }
      });
      
      // 3. Clear localStorage cache for Mermaid
      const mermaidKeys = [
        'mermaid-diagram-cache',
        'mermaid-flowchart-config', 
        'mermaid-sequence-config',
        'mermaid-gantt-config',
        'mermaid-er-config',
        'mermaid-class-config',
        'syntax-error-cache',
        'diagram-render-status'
      ];
      
      mermaidKeys.forEach(key => {
        try {
          localStorage.removeItem(key);
          console.log(`Removed ${key} from localStorage`);
        } catch (e) {
          console.warn(`Failed to remove ${key} from localStorage`, e);
        }
      });
      
      // 4. Try to reset any global mermaid state
      if (window.mermaid) {
        try {
          // Reset internal state objects if possible
          if (window.mermaid.parse && window.mermaid.parse.yy) {
            window.mermaid.parse.yy = {};
            console.log('Reset mermaid parser state');
          }
        } catch (e) {
          console.warn('Error resetting mermaid state:', e);
        }
      }
      
      return true;
    } catch (error) {
      console.error('Error in Mermaid cleanup:', error);
      return false;
    }
  };

  const handleLogin = () => {
    try {
      // First do a thorough cleanup of Mermaid resources
      cleanupMermaidResources();
      
      // Store a flag in sessionStorage to indicate we're coming from chat limit
      sessionStorage.setItem('fromChatLimit', 'true');
      console.log('Set fromChatLimit flag in sessionStorage, navigating to Login');
      
      // Clear any other lingering data that might cause issues
      sessionStorage.removeItem('currentDiagramState');
      sessionStorage.removeItem('lastRenderedDiagram');
      
      // Clear console logs if possible
      if (console.clear) {
        console.clear();
        console.log('Console cleared to remove any error logs');
      }
      
      // Use navigate instead of direct location change for better React integration
      navigate('/Login');
    } catch (error) {
      console.error('Error during popup redirection:', error);
      // Fallback to direct location change if navigation fails
      window.location.href = '/Login';
    }
  };

  return (
    <div className="chat-limit-popup-backdrop" data-visible={isOpen}>
      <div className="chat-limit-popup">
        <div className="chat-limit-popup-content">
          <h2>Thanks for trying us</h2>
          <p>To use full functionality, please login to continue using GeoHub with unlimited conversations.</p>
          <div className="chat-limit-popup-buttons">
            <button className="login-button" onClick={handleLogin}>Sign In For Full Access</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatLimitPopup; 